// Story 1.30 — client-side slug derivation.
//
// Mirrors server/src/services/creator_profile_service.rs::slugify_display_name
// (Story 1.23). The backend validates the slug shape independently;
// this helper is for the composer's auto-derive UX (admin types a
// title → slug field fills in).
//
// Output shape: lowercase ASCII alphanumeric + single hyphens between
// runs. Leading/trailing hyphens stripped. Matches the migration 0021
// CHECK constraint `^[a-z0-9]+(-[a-z0-9]+)*$`.

export function slugify(input: string): string {
  const lowered = input.toLowerCase();
  let out = "";
  let lastWasDash = true; // suppress leading dashes
  for (const c of lowered) {
    if ((c >= "a" && c <= "z") || (c >= "0" && c <= "9")) {
      out += c;
      lastWasDash = false;
    } else if (!lastWasDash) {
      out += "-";
      lastWasDash = true;
    }
  }
  while (out.endsWith("-")) {
    out = out.slice(0, -1);
  }
  return out;
}
